import React, { useState, useRef } from 'react';
import t from 'prop-types';
import { Precarga } from '../../index';
import useOnResize from '../../util/use-onresize';

function Imagen(_ref) {
  var src = _ref.src,
      onLoad = _ref.onLoad,
      onResize = _ref.onResize;

  var _useState = useState(true),
      loading = _useState[0],
      setLoading = _useState[1];

  var imgRef = useRef(null);
  useOnResize(imgRef, onResize);

  function handleLoad() {
    setLoading(false);
    onLoad && onLoad(imgRef);
    var currentRect = imgRef.current.getBoundingClientRect();
    window.console.log('Imagen handleLoad', {
      src: src,
      currentRect: currentRect
    });
    onResize && onResize(currentRect);
  }

  var style = {
    opacity: loading ? 0.0 : 1.0
  };
  return React.createElement(React.Fragment, null, loading && React.createElement(Precarga, null), React.createElement('img', {
    ref: imgRef,
    src: src,
    alt: '',
    style: style,
    onLoad: handleLoad
  }));
}

Imagen.propTypes = process.env.NODE_ENV !== "production" ? {
  src: t.string.isRequired,
  onLoad: t.func,
  onResize: t.func
} : {};
export default Imagen;